// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteInfoItem_wrapper__SjdDA","info":"FavoriteInfoItem_info__aHXHm"};